import PropTypes from 'prop-types';
import { FormProvider } from 'react-hook-form';

/*
#tailwind
*/

const Form = ({ form, onSubmit, children, className, noValidate, ...other }) => (
  <FormProvider {...form} {...other}>
    <form onSubmit={form.handleSubmit(onSubmit)} className={className} noValidate={noValidate}>
      {children}
    </form>
  </FormProvider>
);

Form.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  form: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  children: PropTypes.node,
  className: PropTypes.string,
  noValidate: PropTypes.bool,
};

Form.defaultProps = {
  children: undefined,
  className: undefined,
  noValidate: false,
};

export default Form;
